// extracted by mini-css-extract-plugin
export default {"title":"K5H9k","name":"V0hcJ","description":"BivED","link":"o9JVI","error":"cJatN","refresh":"mT47A"};